import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';
import { MatButtonModule } from '@angular/material/button';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatDialogModule } from '@angular/material/dialog';
import { SafeHtmlPipe } from "./helpers/pipes/safe-html/safe-html.pipe";
import { MaintenanceService } from './services/maintenance/maintenance.service';
import { INTERVAL_DELAY } from './helpers/var/common';
import { AlertComponent } from "./alert/alert.component";

@Component({
  selector: 'app-root',
  standalone: true,
  templateUrl: './app.component.html',
  styleUrl: './../styles.css',
  imports: [CommonModule, HttpClientModule, RouterOutlet, MatButtonModule, MatSnackBarModule, MatDialogModule, SafeHtmlPipe, AlertComponent]
})

export class AppComponent 
{
  title = 'formulaire de saisine'
  isMaintenance:boolean = false
  maintenanceText: string = "Formulaire de saisine en maintenance"
  displayForm:boolean = false

  constructor(
    private maintenanceService:MaintenanceService, 
  ){}

  ngOnInit()
  {
    this.checkMaintenanceInterval()
  }

  checkMaintenanceInterval()
  {
    this.checkIfMaintenance()

    setInterval(() => {
      this.checkIfMaintenance()
    }, INTERVAL_DELAY)
  }

  checkIfMaintenance()
  {
    this.maintenanceService.getData().subscribe(data => {
      const is_maintenance = data?.[0]?.IS_MAINTENANCE
      const contenu = data?.[0]?.CONTENU

      if(contenu) this.maintenanceText = contenu

      if(is_maintenance === true)
      {
        this.toggleMaintenance({status:is_maintenance})
      }
      else
      {
        this.toggleMaintenance({status:false})
      }
    })
  }

  toggleMaintenance(response:{status:boolean})
  {
    this.isMaintenance = response.status

    response.status == true
      ? this.displayForm = false
      : this.displayForm = true
  }
}
